import React, { Component } from 'react';
import { Pie } from 'react-chartjs-2';
import equal from 'fast-deep-equal';
import TreeImgUrl from '../../../assets/illustrations/tree.svg';
import MoneyImgUrl from '../../../assets/illustrations/money.svg';
import MillImgUrl from '../../../assets/illustrations/windmill.svg';

export default class TotalPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      index: `TotalPage`,
      active: false,
      valueFTE: 1,
      total: 0,
    };

    this.chartRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (!equal(this.props, prevProps)) {
      this.setState({ total: this.props.allTotals.co2Totals });
      if (this.props.currentActive === this.state.index) this.setState({ active: true });
      else this.setState({ active: false });
    }
  }

  handleChange(event) {
    this.setState({ valueFTE: event.target.value });
  }

  totalPerFte() {
    let returnValue = (this.props.allTotals.co2Totals / this.state.valueFTE).toFixed(2);

    if (isNaN(returnValue) || !isFinite(returnValue)) {
      returnValue = this.props.allTotals.co2Totals;
    }

    return returnValue;
  }

  render() {
    return (
      <div className='co2calculator__section totalPage' isactive={this.state.active.toString()}>
        <h3 className='center'>Total</h3>
        <div className='totalPage__fields'>
          <label className='totalPage__label'>
            Total emission
            <input
              name='totalCo2'
              className='totalPage__field totalPage__field--display'
              readOnly
              value={`${this.state.total.toFixed(2)} Kg`}
            ></input>
          </label>
          <label className='totalPage__label'>
            Employees
            <input
              className='totalPage__field'
              onChange={(event) => {
                this.handleChange(event);
              }}
              type='numer'
              name='aantalFte'
              value={this.state.valueFTE.toString()}
            />
          </label>
          <label className='totalPage__label'>
            Emission per employee
            <input
              className='totalPage__field totalPage__field--display'
              readOnly
              type='numer'
              name='FteUitstoot'
              value={this.totalPerFte()}
            />
          </label>
        </div>

        <div className='totalPage__wrapper'>
          <div className='totalPage__visuals'>
            <div className='totalPage__visualContainer'>
              <img className='totalPage__image' src={TreeImgUrl}></img>
              <p className='totalPage__text'>
                <span className='totalPage__text--result' id='totalPage-result-boom'>{`${(
                  this.props.allTotals.co2Totals / 20
                ).toFixed(2)} trees`}</span>
                Number of trees that have to grow for a year to include your total CO2 emissions in
                their biomass.
              </p>
            </div>
            <div className='totalPage__visualContainer'>
              <img className='totalPage__image' src={MillImgUrl}></img>
              <p className='totalPage__text'>
                <span id='totalPage-result-watt' className='totalPage__text--result'>{`${(
                  this.props.allTotals.co2Totals / 250
                ).toFixed(2)} hour(s)`}</span>
                Number of hours that a 2.3 Megawatt windmill has to run to prevent your total CO2
                emissions.
              </p>
            </div>
            {/* <div className="totalPage__visualContainer">
                            <img className="totalPage__image" src={MoneyImgUrl}></img>
                            <p className="totalPage__text">
                            <span id="totalPage-result-cost" className="totalPage__text--result">{`${this.props.allTotals.costTotals} euro`}</span>
Uw kosten door uw verbruik.<br></br> Een prijs van € 60 per 1.000 kg CO2 is nodig om klimaatdoelstelling Parijs te halen. <a href="https://www.klimaatplein.com/wereldwijd-co2-prijs-60-dollar-nodig-halen-klimaatakkoord" target="_BLANK">meer info</a>
                            </p>
                        </div> */}
          </div>
          <Pie
            ref={this.chartRef}
            data={this.props.chartData}
            width={500}
            height={500}
            options={{
              maintainAspectRatio: true,
              responsive: true,
              legend: {
                position: 'left', //left
                align: 'center', //center
                labels: {
                  fontSize: 18, //18
                  padding: 18, //18
                  filter: function (legendItem, chartData) {
                    // Logic to remove a particular legend item goes here
                    const dataValue = chartData.datasets[0].data[legendItem.index];

                    if (dataValue != 0) return true;

                    return false;
                    //return chartData[legendItem.index].data.length;
                  },
                },
              },
            }}
          />
        </div>
        <button
          type='button'
          className='co2calculator__nextButton'
          onClick={(e) => {
            document.querySelector('main').scrollIntoView({ alignToTop: true, behavior: 'smooth' });
            this.props.setActive(`SendPage`);
          }}
        >
          Mail me our carbon footprint
        </button>
      </div>
    );
  }
}
